export enum SpecificationsTypes {
  FEATURES = 'Feature',
  SPECIFICATIONS = 'Specification',
}
